import services from "../services";
import * as types from "./mutation-type";
import store from "../../../store";

export const setForm = ({ commit }, payload) => {
    commit(types.SET_FORM, payload);
};

export const setResetModal = ({ commit }, payload) => {
    commit(types.SET_RESET_MODAL, payload);
};

export const setProductTellMeWhenArrive = ({ commit }, payload) => {
    commit(types.SET_PRODUCT, payload);
};

export const getSessionEmail = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.getSessionEmail(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};

export const saveSubscribeTellMeWhenArrive = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.saveSubscribeTellMeWhenArrive(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};

export const submitSaveSubscribeTellMeWhenArrive = ({ dispatch }, payload) => {
    return dispatch("saveSubscribeTellMeWhenArrive", {
        ...payload,
        ...store.state.location
    });
};
